/**
 * Brand constants and site-wide configuration.
 * Single source of truth for brand identity used across all pages,
 * SEO metadata, JSON-LD schemas, and email templates.
 */

export const siteConfig = {
  name: "Aster Decorz",
  shortName: "Aster Decorz",
  subtitle: "Botanical & Home Decor",
  tagline: "Premium Artificial Plants & Home Decor for Elevated Interiors",
  description:
    "Handcrafted artificial plants, trees, hanging greenery and moss walls. Botanical calm that never needs watering.",
  url: "https://asterdecorz.com",
  ogImage: "/og-image.jpg",
  locale: "en-IN",
  currency: "INR" as const,
  currencySymbol: "₹",

  contact: {
    email: "admin@asterdecorz.com",
    phone: "+91-9344580982",
    address: "Tamil Nadu, India",
  },

  brand: {
    alternateNames: ["Asterdecorz", "asterdecorz.com", "Aster Decorz India"],
  },

  social: {
    instagram: "https://instagram.com/asterdecorz",
    pinterest: "https://pinterest.com/asterdecorz",
    twitter: "https://twitter.com/asterdecorz",
  },

  shipping: {
    freeThreshold: 5000, // Free shipping over ₹5,000
    standardDays: "5–7",
    expressDays: "1–2",
    returnDays: 6,
    guaranteeYears: 10,
  },

  pricing: {
    standardShippingFee: 60,
    expressShippingFee: 699,
    freeShippingThreshold: 5000,
    gstRate: 0.18,
    pricesIncludeGst: true,
  },

  seo: {
    titleTemplate: "%s — Aster Decorz",
    // Keyword-led on purpose. "Botanical", "greenery" and "decor" are how the brand talks;
    // "artificial flowers" and "fake plants" are what people type -- a grep of src/ found 84
    // uses of "botanical" and zero of "artificial flowers", while five of the four categories
    // are literally flowering plants. The brand voice is not lost, it moved to the hero and
    // the subheadings, where a human reads it; these two strings are read by crawlers and by
    // people scanning a result list, so they lead with the search term.
    defaultTitle: "Artificial Flowers & Plants for Home Decoration — Aster Decorz",
    defaultDescription:
      "Buy artificial flowers and fake plants online in India — silk flower bushes, faux bonsai trees, artificial topiary and indoor foliage, each with a pot included.",
  },
} as const;

export type SiteConfig = typeof siteConfig;
